import { IState } from '../reducers/auth';

export const isAmbassadorSelector = (state: { auth: IState }): boolean =>
  state.auth.permissions &&
  state.auth.permissions.includes('VIEW_UNRESTRICTED_CANDIDATE_DATA') === false;
